import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import type { ActionMenuProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { ActionMenus } from './ActionMenus';
import type { ExportInvoiceReportsProps } from './types';

const InnerExportInvoiceReports: FC<ExportInvoiceReportsProps> = memo(
  ({ isDisabled, onExport, isLoading }) => {
    const dropDownProps: ActionMenuProps['dropDownProps'] = useMemo(
      () => ({ destroyPopupOnHide: true }),
      []
    );

    return (
      <ActionMenus
        onExport={onExport}
        isDisabled={isDisabled}
        dropDownProps={dropDownProps}
        isLoading={isLoading}
      />
    );
  }
);

InnerExportInvoiceReports.displayName = 'InnerExportInvoiceReports';

export const ExportInvoiceReports: FC<ExportInvoiceReportsProps> = memo(
  ({ isDisabled, onExport, isLoading }) => (
    <SuspenseErrorBoundary>
      <InnerExportInvoiceReports
        isDisabled={isDisabled}
        onExport={onExport}
        isLoading={isLoading}
      />
    </SuspenseErrorBoundary>
  )
);

ExportInvoiceReports.displayName = 'ExportInvoiceReports';
